import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { Notification } from '@ml/notifications/types/interfaces';
import { NotificationType } from '@ml/notifications/types/enums';

@Component({
  selector: 'ml-notification-item',
  template: `
    <div
      fxLayout="column"
      class="notification-item cursor-pointer"
      [ngClass]="{
        'cursor-pointer': cursor
      }"
      (click)="redirect.emit()"
    >
      <div class="mat-subheading-1 no-margin grey-color">
        <strong>{{ notification.message }}</strong>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-between baseline">
        <div fxLayout="column">
          <div class="mat-subheading-1 no-margin grey-color">
            <strong>{{ 'from' | translate }}:</strong>
            {{ notification.fromUser.firstName }}
          </div>
          <div class="mat-subheading-1 no-margin grey-color">
            <strong>{{ 'subject' | translate }}:</strong>
            {{ notification.subject }}
          </div>
        </div>
        <button
          mat-icon-button
          (click)="$event.stopPropagation(); remove.emit()"
        >
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      </div>
    </div>
    <mat-divider></mat-divider>
  `,
  styleUrls: ['./notification-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationItemComponent implements OnInit {
  @Input() notification: Notification;
  @Output() redirect = new EventEmitter();
  @Output() remove = new EventEmitter();
  notificationTypes = NotificationType;

  constructor() {}

  ngOnInit() {}

  get cursor() {
    return (
      this.notification.type === NotificationType.TASK ||
      this.notification.type === NotificationType.ORDER
    );
  }
}
